import { useEffect } from 'react'
import useGetAllCountry from './useGetAllCountry'
import { BASE_COUNTRY_ISO } from '../../constants'
import Cookies from 'js-cookie'
import ls from 'local-storage'
import getCart from '../utilities/get-cart'

// https://medium.com/geographit/accessing-react-state-in-event-listeners-with-usestate-and-useref-hooks-8cceee73c559
export default function useWindowEventListenersEffect(value) {
    const {
        setCountry,
        showCart, setShowCart,
        showNav, setShowNav,
        setScreenWidth,
        setClientWidth,
        searchClicked, setSearchClicked,
    } = value
    
    const allCountry = useGetAllCountry()
    // console.log(allCountry)

    // EVENT LISTENERS THAT DO NOT DEPEND ON APP STATE
    useEffect(() => {
        if (typeof window === 'undefined') return
        if (typeof document === 'undefined') return

        const getCountryByIso = (iso) => {
            const myiso = iso ? iso : BASE_COUNTRY_ISO
            const foundCountry = allCountry.find(({ countryIso }) => countryIso === myiso)
            return foundCountry
        }

        const updateCountry = (country) => {
            const { countryIso, currencyIso } = country
            
            const cookieIso = Cookies.get('eswCountryIso')
            if (cookieIso && (cookieIso === countryIso)) {
                setCountry(country)
            } else {
                Cookies.set('eswCountryIso', countryIso)
                Cookies.set('eswCurrencyIso', currencyIso?.toUpperCase())
                ls.set('SELECTED_COUNTRY_ISO', countryIso)
            }
        }

        const handleGeoip = ({ detail }) => {
            const iso = JSON.parse(detail)?.country?.iso_code
            // console.log('handleGeoip', iso)
            const country = getCountryByIso(iso)
            updateCountry(country)
        }

        const handleCountryCurrencyChanged = ({ detail }) => {
            // console.log('handleCountryCurrencyChanged', detail)
            const iso = detail?.countryIso
            const country = getCountryByIso(iso)
            updateCountry(country)
        }

        const handleEswCountryPicingSet = ({ detail }) => {
            // console.log('handleEswCountryPicingSet', detail)
            const iso = detail?.countryIso
            const country = getCountryByIso(iso)
            setCountry(country)
        }

        const handleResize = (e) => {
            setScreenWidth(e.target.screen.width)
            setClientWidth(e.target.document.body.clientWidth)
        }

        window.addEventListener('resize', handleResize)
        window.addEventListener('MAXMIND_GEO_IP', handleGeoip)
        window.addEventListener('COUNTRY_CURRENCY_CHANGED', handleCountryCurrencyChanged)

        document.addEventListener('ESW_COUNTRY_PRICING_SET', handleEswCountryPicingSet)
        
        return () => {
            window.removeEventListener('MAXMIND_GEO_IP', handleGeoip)
            window.removeEventListener('COUNTRY_CURRENCY_CHANGED', handleCountryCurrencyChanged)
            window.removeEventListener('resize', handleResize)
            document.removeEventListener('ESW_COUNTRY_PRICING_SET', handleEswCountryPicingSet)
        }
    }, [])

    // EVENT LISTENERS THAT DO DEPEND ON APP STATE
    useEffect(() => {
        if (typeof window === 'undefined') return

        const handleCartChange = async (e) => {
            await getCart(e, value)
        }

        const handleNavigate = () => {
            if (showCart) setShowCart(false)
            if (showNav) setShowNav(false)
            if (searchClicked) setSearchClicked(false)
        }

        window.addEventListener('CART_CHANGE', handleCartChange)
        window.addEventListener('NAVIGATE', handleNavigate)

        return () => {
            window.removeEventListener('CART_CHANGE', handleCartChange)
            window.removeEventListener('NAVIGATE', handleNavigate)
        }
    }, [value])
}
